global.version = "1.0.1";
global.i18 = {
    us: {
        "กรุณาชื่อ-นามสกุล": "Please enter your full name.",
        "กรุณากรอกเบอร์โทรศัพท์": "Please enter your phone number.",
        "กรุณากรอกอีเมล": "Please enter your email address.",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "Please enter the correct email format.",
        "กรุณากรอกเบอร์โทร": "Please enter your phone number.",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "Please enter your phone number completely.",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "Please enter your phone number correctly.",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "Thank you for contacting us! We will get back to you as soon as possible.",
        "อ่านเพิ่มเติม": "Read More",
        "สินค้าของเรา เอซีไอ อินซิเนอเรเทอร์": "Our Products: ACI Incinerator",
        "เตาเผาขยะชุมชนสำเร็จรูปที่ออกแบบด้วยเทคโนโลยีญี่ปุ่น ผสานความเชี่ยวชาญของทีมงานไทย มุ่งเน้นประสิทธิภาพในการกำจัดขยะ ความปลอดภัยต่อผู้ใช้งาน และความเป็นมิตรต่อสิ่งแวดล้อม": "Ready-to-use municipal waste incinerators designed with Japanese technology, combined with the expertise of a Thai team, focusing on efficient waste disposal, user safety, and environmental friendliness.",
        "รายละเอียด": "Details",
        "ดูสินค้าเพิ่มเติม": "View More Products",
        "วิธีการใช้งานของเรา - เตาเผาขยะชุมชน": "Our Applications - Municipal Waste Incinerators",
        "งานด้านที่ปรึกษา": "Consulting Services",
        "ในฐานผู้เชี่ยวชาญเตาเผาทุกประเภท บริษัทฯ ได้รับเป็นที่ปรึกษาให้กับบริษัทต่างๆ ในประเทศ": "As experts in all types of incinerators, the company provides consulting services to various companies in Thailand.",
        "สินค้าของเรา": "Our Products",
        "กลุ่มลูกค้าของเรา": "Our Clientele",
        "เตาเผาขยะชุมชนของ ACI Incinerator ได้รับการออกแบบเพื่อตอบโจทย์การใช้งานที่หลากหลาย เหมาะกับทั้งภาครัฐ ภาคเอกชน และชุมชน ที่ต้องการจัดการขยะอย่างมีประสิทธิภาพและเป็นมิตรต่อสิ่งแวดล้อม": "ACI Incinerator's municipal waste incinerators are designed to meet diverse applications, suitable for government agencies, private companies, and communities that want to manage waste efficiently and in an environmentally friendly way.",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "We offer high-quality incinerators, focusing on producing non-polluting incinerators. “Sincere Care for the Environment”",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "We focus on producing environmentally friendly incinerators, and our slogan is… “Truly caring for the environment.”",
        "เรายินดีให้คำปรึกษาเกี่ยวกับการจัดการขยะและการเลือกใช้เตาเผาขยะชุมชนที่เหมาะสมกับความต้องการของคุณ ทีมงานผู้เชี่ยวชาญพร้อมดูแล ให้ข้อมูลครบถ้วน ตั้งแต่การออกแบบ ติดตั้ง ไปจนถึงการบริการหลังการขาย": "We are happy to provide consultation on waste management and selecting the right municipal incinerator to meet your needs. Our team of experts is ready to assist you with complete information, from design and installation to after-sales service.",
        "ติดต่อเราได้ที่": "Contact Us at",
        "เมนูทั้งหมด": "All Menus",
        "หน้าแรก": "Home",
        "เกี่ยวกับเรา": "About Us",
        "มาตรฐานและงานวิจัย": "Standards and Research",
        "ลูกค้า": "Customers",
        "ติดต่อเรา": "Contact Us",
        "ผลิตภัณฑ์แนะนำ": "Featured Products",
        "โทรได้ที่": "Phone",
        "โทรสาร": "Fax",
        "อีเมล": "Email",
        "เว็บไซต์": "Website",
        "ชื่อ - นามสกุล": "Name - Surname",
        "เบอร์โทรศัพท์": "Phone Number",
        "บริษัท": "Company",
        "หัวข้อที่สอบถาม": "Topics of inquiry",
        "ส่งข้อมูล": "Submit",
        "คำอธิบาย": "Description",
        "หากสนใจสามารถติดต่อได้ที่": "If interested, please contact us at",
        "คุณสมบัติทั่วไป": "General Specifications",
        "ข้อมูลทั่วไป": "General Information",
        "คุณสมบัติเฉพาะ รุ่น": "Specific Model Features",
        "ระบบของเตา": "Incinerator System",
        "ขนาด (ประมาณ)": "Size (approx.)",
        "น้ำหนัก (ประมาณ)": "Weight (approx.)",
        "ปริมาณที่เผาได้/ ชม.": "Incineration Capacity/hour",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "Incineration Ratio (Wet:Dry)",
        "ห้องเผาไหม้": "Combustion Chamber",
        "อุณหภูมิในขณะเผาไหม้": "Combustion Temperature",
        "ไม่ใช้เชื้อเพลิงในการเผาไหม้": "Non-Combustion Fuel",
        "เชื้อเพลิงในการเผาไหม้": "Combustion Fuel",
        "ระบบเติมอากาศ": "Aeration System",
        "อายุการใช้งาน": "Service Life",
        "การรับประกัน": "Warranty",
        "ดาวน์โหลดแคตตาล็อก": "Download Catalog",
        "สินค้าอื่นๆ": "Other Products",
        "ทั้งหมด": "All",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "Non-Electric and Fuel Operated",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "Electric and Fuel Operated",
        "ดาวน์โหลดงานวิจัย": "Download Research",
        "สินค้า": "Products",
        "แจ้งเตือน": "Notification",
        "สำเร็จ": "Successful",
    },
    jp: {
        "กรุณาชื่อ-นามสกุล": "氏名（フルネーム）を入力してください。",
        "กรุณากรอกเบอร์โทรศัพท์": "電話番号を入力してください。",
        "กรุณากรอกอีเมล": "メールアドレスを入力してください。",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "正しいメールアドレスの形式を入力してください。",
        "กรุณากรอกเบอร์โทร": "電話番号を入力してください。",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "電話番号を完全に入力してください。",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "電話番号を正しく入力してください。",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "お問い合わせいただきありがとうございます。できるだけ早くご連絡いたします。",
        "อ่านเพิ่มเติม": "続きを読む",
        "สินค้าของเรา เอซีไอ อินซิเนอเรเทอร์": "当社の製品：ACI焼却炉",
        "เตาเผาขยะชุมชนสำเร็จรูปที่ออกแบบด้วยเทคโนโลยีญี่ปุ่น ผสานความเชี่ยวชาญของทีมงานไทย มุ่งเน้นประสิทธิภาพในการกำจัดขยะ ความปลอดภัยต่อผู้ใช้งาน และความเป็นมิตรต่อสิ่งแวดล้อม": "日本の技術とタイチームの専門知識を融合させ、効率的な廃棄物処理、ユーザーの安全性、そして環境への配慮を重視して設計された、すぐに使用できる都市廃棄物焼却炉です。",
        "รายละเอียด": "詳細",
        "ดูสินค้าเพิ่มเติม": "その他の製品を見る",
        "วิธีการใช้งานของเรา - เตาเผาขยะชุมชน": "当社の用途 - 都市廃棄物焼却炉",
        "งานด้านที่ปรึกษา": "コンサルティングサービス",
        "ในฐานผู้เชี่ยวชาญเตาเผาทุกประเภท บริษัทฯ ได้รับเป็นที่ปรึกษาให้กับบริษัทต่างๆ ในประเทศ": "あらゆる種類の焼却炉の専門家として、当社はタイの様々な企業にコンサルティングサービスを提供しています。",
        "สินค้าของเรา": "当社の製品",
        "กลุ่มลูกค้าของเรา": "当社の顧客",
        "เตาเผาขยะชุมชนของ ACI Incinerator ได้รับการออกแบบเพื่อตอบโจทย์การใช้งานที่หลากหลาย เหมาะกับทั้งภาครัฐ ภาคเอกชน และชุมชน ที่ต้องการจัดการขยะอย่างมีประสิทธิภาพและเป็นมิตรต่อสิ่งแวดล้อม": "ACI焼却炉の都市廃棄物焼却炉は、廃棄物を効率的かつ環境に配慮した方法で管理したい政府機関、民間企業、そして地域社会など、多様な用途に対応するように設計されています。",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "当社は、環境に配慮した焼却炉の製造にこだわり、高品質の焼却炉を提供しています。「環境への誠実な配慮」",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "当社は環境に配慮した焼却炉の製造に注力しており、スローガンは「真に環境への配慮」です。",
        "เรายินดีให้คำปรึกษาเกี่ยวกับการจัดการขยะและการเลือกใช้เตาเผาขยะชุมชนที่เหมาะสมกับความต้องการของคุณ ทีมงานผู้เชี่ยวชาญพร้อมดูแล ให้ข้อมูลครบถ้วน ตั้งแต่การออกแบบ ติดตั้ง ไปจนถึงการบริการหลังการขาย": "廃棄物管理に関するご相談や、お客様のニーズに合った最適な焼却炉の選定を喜んで承ります。設計・設置からアフターサービスまで、専門チームがお客様をサポ​​ートいたします。",
        "ติดต่อเราได้ที่": "お問い合わせ",
        "เมนูทั้งหมด": "すべてのメニュー",
        "หน้าแรก": "ホーム",
        "เกี่ยวกับเรา": "会社情報",
        "มาตรฐานและงานวิจัย": "規格と研究",
        "ลูกค้า": "お客様",
        "ติดต่อเรา": "お問い合わせ",
        "ผลิตภัณฑ์แนะนำ": "おすすめ製品",
        "โทรได้ที่": "電話番号",
        "โทรสาร": "FAX番号",
        "อีเมล": "Eメール",
        "เว็บไซต์": "ウェブサイト",
        "ชื่อ - นามสกุล": "氏名（姓・名）",
        "เบอร์โทรศัพท์": "電話番号",
        "บริษัท": "会社名",
        "หัวข้อที่สอบถาม": "お問い合わせ内容",
        "ส่งข้อมูล": "送信",
        "คำอธิบาย": "説明",
        "หากสนใจสามารถติดต่อได้ที่": "ご興味がございましたら、下記までお問い合わせください",
        "คุณสมบัติทั่วไป": "一般仕様",
        "ข้อมูลทั่วไป": "一般情報",
        "คุณสมบัติเฉพาะ รุ่น": "各モデルの特長",
        "ระบบของเตา": "焼却炉システム",
        "ขนาด (ประมาณ)": "サイズ（概算）",
        "น้ำหนัก (ประมาณ)": "重量（概算）",
        "ปริมาณที่เผาได้/ ชม.": "焼却能力（時間あたり）",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "焼却率（湿式：乾式）",
        "ห้องเผาไหม้": "燃焼室",
        "อุณหภูมิในขณะเผาไหม้": "燃焼温度",
        "ไม่ใช้เชื้อเพลิงในการเผาไหม้": "燃焼に燃料を使用しません。",
        "เชื้อเพลิงในการเผาไหม้": "燃焼燃料",
        "ระบบเติมอากาศ": "曝気システム",
        "อายุการใช้งาน": "耐用年数",
        "การรับประกัน": "保証",
        "ดาวน์โหลดแคตตาล็อก": "カタログのダウンロード",
        "สินค้าอื่นๆ": "その他の製品",
        "ทั้งหมด": "すべて",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "非電気式および燃料式",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "電気式および燃料式",
        "ดาวน์โหลดงานวิจัย": "研究資料のダウンロード",
        "สินค้า": "製品",
        "แจ้งเตือน": "通知",
        "สำเร็จ": "成功",
    },
    cn: {

        "กรุณาชื่อ-นามสกุล": "請輸入您的全名。",
        "กรุณากรอกเบอร์โทรศัพท์": "請輸入您的電話號碼。",
        "กรุณากรอกอีเมล": "請輸入您的電子郵件地址。",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "請輸入正確的電子郵件地址格式。",
        "กรุณากรอกเบอร์โทร": "請輸入您的電話號碼。",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "請完整輸入您的電話號碼。",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "請正確輸入您的電話號碼。",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "感謝您與我們聯繫！我們將盡快回覆您。",
        "อ่านเพิ่มเติม": "了解更多",
        "สินค้าของเรา เอซีไอ อินซิเนอเรเทอร์": "我們的產品：ACI 焚燒爐",
        "เตาเผาขยะชุมชนสำเร็จรูปที่ออกแบบด้วยเทคโนโลยีญี่ปุ่น ผสานความเชี่ยวชาญของทีมงานไทย มุ่งเน้นประสิทธิภาพในการกำจัดขยะ ความปลอดภัยต่อผู้ใช้งาน และความเป็นมิตรต่อสิ่งแวดล้อม": "採用日本技術，結合泰國團隊的專業知識，打造即用型城市垃圾焚化爐，專注於高效垃圾處理、使用者安全和環境友善。",
        "รายละเอียด": "詳情",
        "ดูสินค้าเพิ่มเติม": "查看更多產品",
        "วิธีการใช้งานของเรา - เตาเผาขยะชุมชน": "我們的應用 - 都市垃圾焚化爐",
        "งานด้านที่ปรึกษา": "諮詢服務",
        "ในฐานผู้เชี่ยวชาญเตาเผาทุกประเภท บริษัทฯ ได้รับเป็นที่ปรึกษาให้กับบริษัทต่างๆ ในประเทศ": "作為各類焚化爐的專家，我們為泰國多家公司提供諮詢服務。",
        "สินค้าของเรา": "我們的產品",
        "กลุ่มลูกค้าของเรา": "我們的客戶",
        "เตาเผาขยะชุมชนของ ACI Incinerator ได้รับการออกแบบเพื่อตอบโจทย์การใช้งานที่หลากหลาย เหมาะกับทั้งภาครัฐ ภาคเอกชน และชุมชน ที่ต้องการจัดการขยะอย่างมีประสิทธิภาพและเป็นมิตรต่อสิ่งแวดล้อม": "ACI 焚化爐的都市垃圾焚化爐旨在滿足各種應用需求，適用於希望以高效且環保的方式管理垃圾的政府機構、私人企業和社區。",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "我們提供高品質的焚燒爐，專注於生產無污染焚化爐。 “真心關懷環境”",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "我們致力於生產環保焚化爐，我們的口號是…「真正關懷環境」。",
        "เรายินดีให้คำปรึกษาเกี่ยวกับการจัดการขยะและการเลือกใช้เตาเผาขยะชุมชนที่เหมาะสมกับความต้องการของคุณ ทีมงานผู้เชี่ยวชาญพร้อมดูแล ให้ข้อมูลครบถ้วน ตั้งแต่การออกแบบ ติดตั้ง ไปจนถึงการบริการหลังการขาย": "我們樂於為您提供廢棄物管理方面的諮詢服務，並協助您選擇合適的市政焚化爐以滿足您的需求。我們的專家團隊隨時準備為您提供從設計、安裝到售後服務的全方位資訊。",
        "ติดต่อเราได้ที่": "聯絡我們",
        "เมนูทั้งหมด": "所有選單",
        "หน้าแรก": "首頁",
        "เกี่ยวกับเรา": "關於我們",
        "มาตรฐานและงานวิจัย": "標準與研究",
        "ลูกค้า": "客戶",
        "ติดต่อเรา": "聯絡我們",
        "ผลิตภัณฑ์แนะนำ": "特色產品",
        "โทรได้ที่": "電話",
        "โทรสาร": "傳真",
        "อีเมล": "電子郵件",
        "เว็บไซต์": "網站",
        "ชื่อ - นามสกุล": "姓名",
        "เบอร์โทรศัพท์": "電話號碼",
        "บริษัท": "公司",
        "หัวข้อที่สอบถาม": "諮詢主題",
        "ส่งข้อมูล": "提交",
        "คำอธิบาย": "描述",
        "หากสนใจสามารถติดต่อได้ที่": "如有興趣，請聯絡我們",
        "คุณสมบัติทั่วไป": "一般規格",
        "ข้อมูลทั่วไป": "一般資訊",
        "คุณสมบัติเฉพาะ รุ่น": "特定型號功能",
        "ระบบของเตา": "焚燒爐系統",
        "ขนาด (ประมาณ)": "尺寸（約）",
        "น้ำหนัก (ประมาณ)": "重量（約）",
        "ปริมาณที่เผาได้/ ชม.": "每小時焚燒量",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "焚燒比（濕：乾）",
        "ห้องเผาไหม้": "燃燒室",
        "อุณหภูมิในขณะเผาไหม้": "燃燒溫度",
        "ไม่ใช้เชื้อเพลิงในการเผาไหม้": "它不需要燃料燃燒",
        "เชื้อเพลิงในการเผาไหม้": "燃燒燃料",
        "ระบบเติมอากาศ": "通風系統",
        "อายุการใช้งาน": "使用壽命",
        "การรับประกัน": "保固",
        "ดาวน์โหลดแคตตาล็อก": "下載產品目錄",
        "สินค้าอื่นๆ": "其他產品",
        "ทั้งหมด": "全部",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "非電動和燃油式",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "電動和燃油式",
        "ดาวน์โหลดงานวิจัย": "下載研究報告",
        "สินค้า": "產品",
        "แจ้งเตือน": "通知",
        "สำเร็จ": "成功",
    }
}